import { NgModule } from '@angular/core';
import { CartBaseModule } from "@spartacus/cart/base";
import { CartBaseCoreModule, CartPageEventModule } from '@spartacus/cart/base/core';
import { WishListModule } from '@spartacus/cart/wish-list';
import { CheckoutComponentsModule, CheckoutLoginModule } from '@spartacus/checkout/base/components';
import { CheckoutCoreModule } from '@spartacus/checkout/base/core';
import { CheckoutOccModule } from '@spartacus/checkout/base/occ';
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ProductModule,
  ProductOccModule,
  UserOccModule,
  provideConfig,
  provideFeatureToggles,
} from '@spartacus/core';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PaymentMethodsModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule,
  UserComponentModule
} from '@spartacus/storefront';
import {
  AddressBookModule,
  CloseAccountModule, ForgotPasswordModule, ResetPasswordModule,
  UpdateEmailModule,
  UpdatePasswordModule,
  UpdateProfileModule
} from '@spartacus/user/profile/components';
import { uigAddedToCartDialogLayoutConfig } from "../config/uig-added-to-cart-layout-config";
import { uigCartNotesDialogLayoutConfig } from "../config/uig-cart-notes-layout-config";
import { uigEmptyCartComponentDialogLayoutConfig } from "../config/uig-empty-cart-layout-config";
import { uigTermsConditionsDialogLayoutConfig } from '../config/uig-terms-and-conditions-layout-config';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { WishListFeatureModule } from './features/cart/wish-list-feature.module';
import { OrderFeatureModule } from "./features/order/order-feature.module";
import { OrganizationAdministrationFeatureModule } from './features/organization/organization-administration-feature.module';
import { ProductImageZoomFeatureModule } from './features/product/product-image-zoom-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { UserFeatureModule } from './features/user/user-feature.module';
import { uigFeatureToggles } from '../config/uig-feature-toggles';

@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    UserOccModule,
    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    // User UI,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    // Anonymous Consents Core,
    AnonymousConsentsModule.forRoot(),
    // Anonymous Consents UI,
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    // Product Core,
    ProductModule.forRoot(),
    ProductOccModule,
    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    ProductImageZoomFeatureModule,
    // Cart Core,
    WishListModule,
    CartBaseModule,
    // Checkout Core,
    CheckoutCoreModule,
    CheckoutOccModule,
    CostCenterOccModule,
    // Checkout UI,
    CheckoutLoginModule,
    CheckoutComponentsModule,
    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,
    UserFeatureModule,
    SmartEditFeatureModule,
    OrganizationAdministrationFeatureModule,
    CartSavedCartFeatureModule,
    UserComponentModule,
    CloseAccountModule,
    UpdateEmailModule,
    UpdatePasswordModule,
    UpdateProfileModule,
    ForgotPasswordModule,
    ResetPasswordModule,
    CartBaseCoreModule,
    WishListFeatureModule,
    OrderFeatureModule
  ],
  providers: [
    provideConfig(uigTermsConditionsDialogLayoutConfig),
    provideConfig(uigEmptyCartComponentDialogLayoutConfig),
    provideConfig(uigCartNotesDialogLayoutConfig),
    provideConfig(uigAddedToCartDialogLayoutConfig),
    provideFeatureToggles(uigFeatureToggles),
    provideConfig({
      features: {
        a11yKeyboardAccessibleZoom: false,
      },
    }),
  ],
})
export class SpartacusFeaturesModule { }

